// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.preview_wAqjx {
	display: inline-flex;
	justify-content: center;
	height: 100%;
	width: 100%;
	overflow: visible !important;
	.left_fKA7H {
		display: inline-flex;
		flex-direction: column;
		gap: 14px;
		min-width: 240px;
		width: 240px;
		padding: 20px 10px;
		overflow-y: scroll;
		background: var(--white-color);
		border: 1px solid var(--border-color);
		overflow-x: visible !important;
		&::-webkit-scrollbar {
			display: none;
		}
		.title_PR4hd {
			display: inline-flex;
			position: relative;
			flex-direction: column;
			gap: 2px;
			align-items: flex-end;
			input {
				width: 100%;
				background: var(--f5-background);
				border: 1px solid var(--border-color);
				padding: 6px 9px;
				border-radius: 4px;
				font-size: 18px;
				font-family: inherit;
			}
			span {
				font-size: 14px;
				color: var(--text-color-secondary);
			}
		}
		.options_nq74y {
			b {
				font-size: 16px;
				font-weight: 700;
				margin-bottom: 5px;
			}
			ul {
				flex-direction: column;
				display: inline-flex;
				align-items: flex-start;
				gap: 8px;
				width: 100%;
				margin: 10px 0px;
				li {
					display: inline-flex;
					align-items: center;
					gap: 12px;
					font-size: 14px;
					font-weight: 500;
					input {
						width: 20px;
						height: 20px;
						border-radius: 4px;
						border: 1px solid var(--border-color);
					}
				}
			}
		}
		.color_FGC9x {
			position: relative;
			b {
			}
			ul {
				width: 100%;
				margin: 10px 0px;
				display: grid;
				grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
				li {
					width: 30px;
					height: 30px;
					display: inline-flex;
					align-items: center;
					justify-content: center;
				}
			}
		}
		.border_EWrWl {
			display: inline-flex;
			align-items: center;
			gap: 6px;
			input {
				width: 20px;
				height: 20px;
				border-radius: 4px;
				border: 1px solid var(--border-color);
			}
		}
		.form_rlURZ {
			display: flex;
			flex-direction: column;
			gap: 7px;
			ul {
				display: inline-flex;
				flex-direction: column;
				gap: 6px;
				width: 100%;
				li {
					display: flex;
					flex-direction: column;
					gap: 2px;
					position: relative;
					border: 1px solid var(--border-color);
					background: var(--white-color);
					padding: 2px 6px;

					label {
						font-size: 12px;
					}
					span {
						font-size: 15px;
					}
					svg {
						position: absolute;
						top: 10px;
						right: 0px;
						min-width: 20px;
						min-height: 20px;
						width: 20px;
						height: 20px;
					}
					ul {
						display: none;
						width: 100%;
						position: absolute;
						top: 0px;
						left: 0px;
						background: var(--white-color);
						li {
						}
					}
				}
			}
		}
		.shows_omyiz {
			b {
				font-size: 16px;
				font-weight: 700;
			}
		}
	}
	.right_uqinm {
		padding: 20px;
		display: inline-flex;
		width: 100%;
		flex-direction: column;
		gap: 10px;
		overflow-y: scroll;
		.input_hTCcN {
			display: inline-flex;
			flex-direction: column;
			gap: 2px;
			position: relative;
			background: var(--white-color);
			padding: 7px;
			border: 1px solid var(--border-color);
			border-radius: 4px;
			label {
				font-size: 12px;
			}
			input {
				font-size: 14px;
			}
			svg {
				position: absolute;
				min-width: 14px;
				min-height: 14px;
				right: 0px;
				top: 0px;
			}
		}
		small {
		}
		.preview_wAqjx {
			display: inline-flex;
			flex-direction: column;
			gap: 2px;
			.header_gK1hO {
				display: flex;
				flex-direction: column;
				.title_PR4hd {
					display: inline-flex;
					align-items: center;
					gap: 4px;
					justify-content: space-between;
					padding: 4px 10px;
					font-size: 18px;
					font-weight: 600;
				}
				> div {
					display: inline-flex;
					align-items: center;
					gap: 4px;
					justify-content: space-between;
					padding: 4px 10px;
					> div {
						display: inline-flex;
						align-items: center;
						gap: 4px;
					}
					.buttonsNavs_SwPBl {
						display: inline-flex;
						align-items: center;
						gap: 4px;
						button {
							width: 25px;
							height: 25px;
							display: inline-flex;
							align-items: center;
							justify-content: center;
							border: 1px solid var(--border-color);
							svg {
								width: 16px;
								color: var(--_10a37f-background);
							}
						}
					}
					.buttons_yXzkD {
						display: inline-flex;
						gap: 4px;
						align-items: center;
						button {
							padding: 3px 10px;
							border-radius: 3px;
							border: none;
							outline: none;
							font-size: 12px;
							font-weight: 600;
							font-family: inherit;
							cursor: pointer;
							background: var(--_16c0982e-background);
							color: var(--_10a37f-background);
							&:hover {
								background: var(--_16c0982e-background);
							}
						}
					}
				}
			}
			.calendar_XHVXd {
				background: var(--white-color);
			}
			.footer_eGrwK {
				display: inline-flex;
				align-items: center;
				padding: 9px;
				gap: 12px;
				p {
					font-size: 12px;
					font-weight: 500;
				}
				div {
					display: flex;
					align-items: center;
				}
			}
		}
	}
}

[class^='calendarMonth'] {
	td {
		height: calc((100vh / 5) - 70px);
	}
}

.date_FTHAO {
	display: flex;
	align-items: center;
	margin-right: 5px;
	justify-content: space-between;
	b {
		font-size: 12px;
		font-weight: 600;
	}
	div {
		display: flex;
		align-items: center;
		gap: 5px;

		button {
			display: flex;
			align-items: center;
			justify-content: center;
			transition:
				background 0.2s ease-in-out,
				transform 0.1s ease-in-out;
			cursor: pointer;
			-webkit-user-select: none;
			        user-select: none;

			width: 25px;
			height: 25px;
			background: var(--_16c0982e-background);
			color: var(--_10a37f-background);
			border-radius: 4px;
			&:hover {
				background: var(--_16c0982e-background);
				transform: scale(1.05);
			}

			&:active {
				background: var(--_16c098-color);
				transform: scale(0.95);
			}
			svg {
				width: 11px;
				height: 11px;
			}
		}
	}
}

.toDay_YaOPB {
	border: 1px solid var(--_16c0982e-background);
	border-radius: 4px;
	width: 40px;
	min-width: 40px;
	height: 25px;
	min-height: 25px;
	cursor: pointer;
	font-family: inherit;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 14px;
	margin-right: 5px;
}
.actualToday_tgRKV {
	background: var(--_16c098-background);
	border: none;
	cursor: pointer;
	font-family: inherit;
	color: var(--white-color);
	width: 40px;
	min-width: 40px;
	height: 25px;
	min-height: 25px;
	border: 1px solid var(--_16c098-background);
	width: max-content;
	border-radius: 4px;
	font-size: 14px;
}

.saveCalendarTitle_i2LBy {
	position: absolute;
	top: 45px;
	left: 0;
	border-radius: 4px;
	background: var(--_16c09821-background);
	color: var(--white-color);
	padding: 4px 10px;
	display: flex;
	cursor: pointer;
	-webkit-user-select: none;
	        user-select: none;
	font-size: 12px;
	align-items: center;
	justify-content: center;
	transition: background 0.2s ease-in-out;
	&:hover {
		background-color: var(--_16c098-background);
	}
}
.color_FGC9x {
	z-index: 900000;
}
.colorCard_DqJCW {
	min-width: 20px;
	min-height: 20px;
	cursor: pointer;
	-webkit-user-select: none;
	        user-select: none;
	border: 1px solid var(--overlay-3);
	border-radius: 50%;
	position: relative;
	background: var(--border-color);
	position: relative;
	span {
		display: none;
	}
}

.tooltip_YZ3hM {
	position: fixed;
	background-color: #333;
	color: var(--white-color);
	padding: 4px 8px;
	border-radius: 4px;
	font-size: 12px;
	white-space: nowrap;
	z-index: 950000;
}

.defaultBgButton_u2OQE {
	position: absolute;
	top: 0px;
	right: 0px;
	border-radius: 4px;
	background: var(--_16c098-color);
	color: var(--white-color);
	padding: 3px 8px;
	display: flex;
	cursor: pointer;
	-webkit-user-select: none;
	        user-select: none;
	font-size: 11px;
	align-items: center;
	justify-content: center;
	transition: background 0.2s ease-in-out;
	&:hover {
		background-color: var(--e6fff9-background);
	}
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/CalendarView/Calendar/preview.module.css"],"names":[],"mappings":"AAAA;CACC,oBAAoB;CACpB,uBAAuB;CACvB,YAAY;CACZ,WAAW;CACX,4BAA4B;CAC5B;EACC,oBAAoB;EACpB,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,qCAAqC;EACrC,8BAA8B;EAC9B;GACC,aAAa;EACd;EACA;GACC,oBAAoB;GACpB,kBAAkB;GAClB,sBAAsB;GACtB,QAAQ;GACR,qBAAqB;GACrB;IACC,WAAW;IACX,gCAAgC;IAChC,qCAAqC;IACrC,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;GACrB;GACA;IACC,eAAe;IACf,kCAAkC;GACnC;EACD;EACA;GACC;IACC,eAAe;IACf,gBAAgB;IAChB,kBAAkB;GACnB;GACA;IACC,sBAAsB;IACtB,oBAAoB;IACpB,uBAAuB;IACvB,QAAQ;IACR,WAAW;IACX,gBAAgB;IAChB;KACC,oBAAoB;KACpB,mBAAmB;KACnB,SAAS;KACT,eAAe;KACf,gBAAgB;KAChB;MACC,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,qCAAqC;KACtC;IACD;GACD;EACD;EACA;GACC,kBAAkB;GAClB;GACA;GACA;IACC,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,kDAAkD;IAClD;KACC,WAAW;KACX,YAAY;KACZ,oBAAoB;KACpB,mBAAmB;KACnB,uBAAuB;IACxB;GACD;EACD;EACA;GACC,oBAAoB;GACpB,mBAAmB;GACnB,QAAQ;GACR;IACC,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;GACtC;EACD;EACA;GACC,aAAa;GACb,sBAAsB;GACtB,QAAQ;GACR;IACC,oBAAoB;IACpB,sBAAsB;IACtB,QAAQ;IACR,WAAW;IACX;KACC,aAAa;KACb,sBAAsB;KACtB,QAAQ;KACR,kBAAkB;KAClB,qCAAqC;KACrC,8BAA8B;KAC9B,gBAAgB;;KAEhB;MACC,eAAe;KAChB;KACA;MACC,eAAe;KAChB;KACA;MACC,kBAAkB;MAClB,SAAS;MACT,UAAU;MACV,eAAe;MACf,gBAAgB;MAChB,WAAW;MACX,YAAY;KACb;KACA;MACC,aAAa;MACb,WAAW;MACX,kBAAkB;MAClB,QAAQ;MACR,SAAS;MACT,8BAA8B;MAC9B;MACA;KACD;IACD;GACD;EACD;EACA;GACC;IACC,eAAe;IACf,gBAAgB;GACjB;EACD;CACD;CACA;EACC,aAAa;EACb,oBAAoB;EACpB,WAAW;EACX,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB;GACC,oBAAoB;GACpB,sBAAsB;GACtB,QAAQ;GACR,kBAAkB;GAClB,8BAA8B;GAC9B,YAAY;GACZ,qCAAqC;GACrC,kBAAkB;GAClB;IACC,eAAe;GAChB;GACA;IACC,eAAe;GAChB;GACA;IACC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,QAAQ;GACT;EACD;EACA;EACA;EACA;GACC,oBAAoB;GACpB,sBAAsB;GACtB,QAAQ;GACR;IACC,aAAa;IACb,sBAAsB;IACtB;KACC,oBAAoB;KACpB,mBAAmB;KACnB,QAAQ;KACR,8BAA8B;KAC9B,iBAAiB;KACjB,eAAe;KACf,gBAAgB;IACjB;IACA;KACC,oBAAoB;KACpB,mBAAmB;KACnB,QAAQ;KACR,8BAA8B;KAC9B,iBAAiB;KACjB;MACC,oBAAoB;MACpB,mBAAmB;MACnB,QAAQ;KACT;KACA;MACC,oBAAoB;MACpB,mBAAmB;MACnB,QAAQ;MACR;OACC,WAAW;OACX,YAAY;OACZ,oBAAoB;OACpB,mBAAmB;OACnB,uBAAuB;OACvB,qCAAqC;OACrC;QACC,WAAW;QACX,gCAAgC;OACjC;MACD;KACD;KACA;MACC,oBAAoB;MACpB,QAAQ;MACR,mBAAmB;MACnB;OACC,iBAAiB;OACjB,kBAAkB;OAClB,YAAY;OACZ,aAAa;OACb,eAAe;OACf,gBAAgB;OAChB,oBAAoB;OACpB,eAAe;OACf,uCAAuC;OACvC,gCAAgC;OAChC;QACC,uCAAuC;OACxC;MACD;KACD;IACD;GACD;GACA;IACC,8BAA8B;GAC/B;GACA;IACC,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,SAAS;IACT;KACC,eAAe;KACf,gBAAgB;IACjB;IACA;KACC,aAAa;KACb,mBAAmB;IACpB;GACD;EACD;CACD;AACD;;AAEA;CACC;EACC,gCAAgC;CACjC;AACD;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,iBAAiB;CACjB,8BAA8B;CAC9B;EACC,eAAe;EACf,gBAAgB;CACjB;CACA;EACC,aAAa;EACb,mBAAmB;EACnB,QAAQ;;EAER;GACC,aAAa;GACb,mBAAmB;GACnB,uBAAuB;GACvB;;8BAE2B;GAC3B,eAAe;GACf,yBAAiB;WAAjB,iBAAiB;;GAEjB,WAAW;GACX,YAAY;GACZ,uCAAuC;GACvC,gCAAgC;GAChC,kBAAkB;GAClB;IACC,uCAAuC;IACvC,sBAAsB;GACvB;;GAEA;IACC,gCAAgC;IAChC,sBAAsB;GACvB;GACA;IACC,WAAW;IACX,YAAY;GACb;EACD;CACD;AACD;;AAEA;CACC,6CAA6C;CAC7C,kBAAkB;CAClB,WAAW;CACX,eAAe;CACf,YAAY;CACZ,gBAAgB;CAChB,eAAe;CACf,oBAAoB;CACpB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,eAAe;CACf,iBAAiB;AAClB;AACA;CACC,qCAAqC;CACrC,YAAY;CACZ,eAAe;CACf,oBAAoB;CACpB,yBAAyB;CACzB,WAAW;CACX,eAAe;CACf,YAAY;CACZ,gBAAgB;CAChB,2CAA2C;CAC3C,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,OAAO;CACP,kBAAkB;CAClB,uCAAuC;CACvC,yBAAyB;CACzB,iBAAiB;CACjB,aAAa;CACb,eAAe;CACf,yBAAiB;SAAjB,iBAAiB;CACjB,eAAe;CACf,mBAAmB;CACnB,uBAAuB;CACvB,uCAAuC;CACvC;EACC,2CAA2C;CAC5C;AACD;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,eAAe;CACf,yBAAiB;SAAjB,iBAAiB;CACjB,kCAAkC;CAClC,kBAAkB;CAClB,kBAAkB;CAClB,+BAA+B;CAC/B,kBAAkB;CAClB;EACC,aAAa;CACd;AACD;;AAEA;CACC,eAAe;CACf,sBAAsB;CACtB,yBAAyB;CACzB,gBAAgB;CAChB,kBAAkB;CAClB,eAAe;CACf,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,UAAU;CACV,kBAAkB;CAClB,gCAAgC;CAChC,yBAAyB;CACzB,gBAAgB;CAChB,aAAa;CACb,eAAe;CACf,yBAAiB;SAAjB,iBAAiB;CACjB,eAAe;CACf,mBAAmB;CACnB,uBAAuB;CACvB,uCAAuC;CACvC;EACC,0CAA0C;CAC3C;AACD","sourcesContent":[".preview {\n\tdisplay: inline-flex;\n\tjustify-content: center;\n\theight: 100%;\n\twidth: 100%;\n\toverflow: visible !important;\n\t.left {\n\t\tdisplay: inline-flex;\n\t\tflex-direction: column;\n\t\tgap: 14px;\n\t\tmin-width: 240px;\n\t\twidth: 240px;\n\t\tpadding: 20px 10px;\n\t\toverflow-y: scroll;\n\t\tbackground: var(--white-color);\n\t\tborder: 1px solid var(--border-color);\n\t\toverflow-x: visible !important;\n\t\t&::-webkit-scrollbar {\n\t\t\tdisplay: none;\n\t\t}\n\t\t.title {\n\t\t\tdisplay: inline-flex;\n\t\t\tposition: relative;\n\t\t\tflex-direction: column;\n\t\t\tgap: 2px;\n\t\t\talign-items: flex-end;\n\t\t\tinput {\n\t\t\t\twidth: 100%;\n\t\t\t\tbackground: var(--f5-background);\n\t\t\t\tborder: 1px solid var(--border-color);\n\t\t\t\tpadding: 6px 9px;\n\t\t\t\tborder-radius: 4px;\n\t\t\t\tfont-size: 18px;\n\t\t\t\tfont-family: inherit;\n\t\t\t}\n\t\t\tspan {\n\t\t\t\tfont-size: 14px;\n\t\t\t\tcolor: var(--text-color-secondary);\n\t\t\t}\n\t\t}\n\t\t.options {\n\t\t\tb {\n\t\t\t\tfont-size: 16px;\n\t\t\t\tfont-weight: 700;\n\t\t\t\tmargin-bottom: 5px;\n\t\t\t}\n\t\t\tul {\n\t\t\t\tflex-direction: column;\n\t\t\t\tdisplay: inline-flex;\n\t\t\t\talign-items: flex-start;\n\t\t\t\tgap: 8px;\n\t\t\t\twidth: 100%;\n\t\t\t\tmargin: 10px 0px;\n\t\t\t\tli {\n\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tgap: 12px;\n\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\tinput {\n\t\t\t\t\t\twidth: 20px;\n\t\t\t\t\t\theight: 20px;\n\t\t\t\t\t\tborder-radius: 4px;\n\t\t\t\t\t\tborder: 1px solid var(--border-color);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.color {\n\t\t\tposition: relative;\n\t\t\tb {\n\t\t\t}\n\t\t\tul {\n\t\t\t\twidth: 100%;\n\t\t\t\tmargin: 10px 0px;\n\t\t\t\tdisplay: grid;\n\t\t\t\tgrid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;\n\t\t\t\tli {\n\t\t\t\t\twidth: 30px;\n\t\t\t\t\theight: 30px;\n\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.border {\n\t\t\tdisplay: inline-flex;\n\t\t\talign-items: center;\n\t\t\tgap: 6px;\n\t\t\tinput {\n\t\t\t\twidth: 20px;\n\t\t\t\theight: 20px;\n\t\t\t\tborder-radius: 4px;\n\t\t\t\tborder: 1px solid var(--border-color);\n\t\t\t}\n\t\t}\n\t\t.form {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tgap: 7px;\n\t\t\tul {\n\t\t\t\tdisplay: inline-flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\tgap: 6px;\n\t\t\t\twidth: 100%;\n\t\t\t\tli {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tflex-direction: column;\n\t\t\t\t\tgap: 2px;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tborder: 1px solid var(--border-color);\n\t\t\t\t\tbackground: var(--white-color);\n\t\t\t\t\tpadding: 2px 6px;\n\n\t\t\t\t\tlabel {\n\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t}\n\t\t\t\t\tspan {\n\t\t\t\t\t\tfont-size: 15px;\n\t\t\t\t\t}\n\t\t\t\t\tsvg {\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\ttop: 10px;\n\t\t\t\t\t\tright: 0px;\n\t\t\t\t\t\tmin-width: 20px;\n\t\t\t\t\t\tmin-height: 20px;\n\t\t\t\t\t\twidth: 20px;\n\t\t\t\t\t\theight: 20px;\n\t\t\t\t\t}\n\t\t\t\t\tul {\n\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\ttop: 0px;\n\t\t\t\t\t\tleft: 0px;\n\t\t\t\t\t\tbackground: var(--white-color);\n\t\t\t\t\t\tli {\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.shows {\n\t\t\tb {\n\t\t\t\tfont-size: 16px;\n\t\t\t\tfont-weight: 700;\n\t\t\t}\n\t\t}\n\t}\n\t.right {\n\t\tpadding: 20px;\n\t\tdisplay: inline-flex;\n\t\twidth: 100%;\n\t\tflex-direction: column;\n\t\tgap: 10px;\n\t\toverflow-y: scroll;\n\t\t.input {\n\t\t\tdisplay: inline-flex;\n\t\t\tflex-direction: column;\n\t\t\tgap: 2px;\n\t\t\tposition: relative;\n\t\t\tbackground: var(--white-color);\n\t\t\tpadding: 7px;\n\t\t\tborder: 1px solid var(--border-color);\n\t\t\tborder-radius: 4px;\n\t\t\tlabel {\n\t\t\t\tfont-size: 12px;\n\t\t\t}\n\t\t\tinput {\n\t\t\t\tfont-size: 14px;\n\t\t\t}\n\t\t\tsvg {\n\t\t\t\tposition: absolute;\n\t\t\t\tmin-width: 14px;\n\t\t\t\tmin-height: 14px;\n\t\t\t\tright: 0px;\n\t\t\t\ttop: 0px;\n\t\t\t}\n\t\t}\n\t\tsmall {\n\t\t}\n\t\t.preview {\n\t\t\tdisplay: inline-flex;\n\t\t\tflex-direction: column;\n\t\t\tgap: 2px;\n\t\t\t.header {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\t.title {\n\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tgap: 4px;\n\t\t\t\t\tjustify-content: space-between;\n\t\t\t\t\tpadding: 4px 10px;\n\t\t\t\t\tfont-size: 18px;\n\t\t\t\t\tfont-weight: 600;\n\t\t\t\t}\n\t\t\t\t> div {\n\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tgap: 4px;\n\t\t\t\t\tjustify-content: space-between;\n\t\t\t\t\tpadding: 4px 10px;\n\t\t\t\t\t> div {\n\t\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tgap: 4px;\n\t\t\t\t\t}\n\t\t\t\t\t.buttonsNavs {\n\t\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tgap: 4px;\n\t\t\t\t\t\tbutton {\n\t\t\t\t\t\t\twidth: 25px;\n\t\t\t\t\t\t\theight: 25px;\n\t\t\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\t\tborder: 1px solid var(--border-color);\n\t\t\t\t\t\t\tsvg {\n\t\t\t\t\t\t\t\twidth: 16px;\n\t\t\t\t\t\t\t\tcolor: var(--_10a37f-background);\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t.buttons {\n\t\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\t\tgap: 4px;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tbutton {\n\t\t\t\t\t\t\tpadding: 3px 10px;\n\t\t\t\t\t\t\tborder-radius: 3px;\n\t\t\t\t\t\t\tborder: none;\n\t\t\t\t\t\t\toutline: none;\n\t\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\t\t\tfont-family: inherit;\n\t\t\t\t\t\t\tcursor: pointer;\n\t\t\t\t\t\t\tbackground: var(--_16c0982e-background);\n\t\t\t\t\t\t\tcolor: var(--_10a37f-background);\n\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\tbackground: var(--_16c0982e-background);\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.calendar {\n\t\t\t\tbackground: var(--white-color);\n\t\t\t}\n\t\t\t.footer {\n\t\t\t\tdisplay: inline-flex;\n\t\t\t\talign-items: center;\n\t\t\t\tpadding: 9px;\n\t\t\t\tgap: 12px;\n\t\t\t\tp {\n\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\tfont-weight: 500;\n\t\t\t\t}\n\t\t\t\tdiv {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n[class^='calendarMonth'] {\n\ttd {\n\t\theight: calc((100vh / 5) - 70px);\n\t}\n}\n\n.date {\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-right: 5px;\n\tjustify-content: space-between;\n\tb {\n\t\tfont-size: 12px;\n\t\tfont-weight: 600;\n\t}\n\tdiv {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 5px;\n\n\t\tbutton {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\ttransition:\n\t\t\t\tbackground 0.2s ease-in-out,\n\t\t\t\ttransform 0.1s ease-in-out;\n\t\t\tcursor: pointer;\n\t\t\tuser-select: none;\n\n\t\t\twidth: 25px;\n\t\t\theight: 25px;\n\t\t\tbackground: var(--_16c0982e-background);\n\t\t\tcolor: var(--_10a37f-background);\n\t\t\tborder-radius: 4px;\n\t\t\t&:hover {\n\t\t\t\tbackground: var(--_16c0982e-background);\n\t\t\t\ttransform: scale(1.05);\n\t\t\t}\n\n\t\t\t&:active {\n\t\t\t\tbackground: var(--_16c098-color);\n\t\t\t\ttransform: scale(0.95);\n\t\t\t}\n\t\t\tsvg {\n\t\t\t\twidth: 11px;\n\t\t\t\theight: 11px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.toDay {\n\tborder: 1px solid var(--_16c0982e-background);\n\tborder-radius: 4px;\n\twidth: 40px;\n\tmin-width: 40px;\n\theight: 25px;\n\tmin-height: 25px;\n\tcursor: pointer;\n\tfont-family: inherit;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-size: 14px;\n\tmargin-right: 5px;\n}\n.actualToday {\n\tbackground: var(--_16c098-background);\n\tborder: none;\n\tcursor: pointer;\n\tfont-family: inherit;\n\tcolor: var(--white-color);\n\twidth: 40px;\n\tmin-width: 40px;\n\theight: 25px;\n\tmin-height: 25px;\n\tborder: 1px solid var(--_16c098-background);\n\twidth: max-content;\n\tborder-radius: 4px;\n\tfont-size: 14px;\n}\n\n.saveCalendarTitle {\n\tposition: absolute;\n\ttop: 45px;\n\tleft: 0;\n\tborder-radius: 4px;\n\tbackground: var(--_16c09821-background);\n\tcolor: var(--white-color);\n\tpadding: 4px 10px;\n\tdisplay: flex;\n\tcursor: pointer;\n\tuser-select: none;\n\tfont-size: 12px;\n\talign-items: center;\n\tjustify-content: center;\n\ttransition: background 0.2s ease-in-out;\n\t&:hover {\n\t\tbackground-color: var(--_16c098-background);\n\t}\n}\n.color {\n\tz-index: 900000;\n}\n.colorCard {\n\tmin-width: 20px;\n\tmin-height: 20px;\n\tcursor: pointer;\n\tuser-select: none;\n\tborder: 1px solid var(--overlay-3);\n\tborder-radius: 50%;\n\tposition: relative;\n\tbackground: var(--border-color);\n\tposition: relative;\n\tspan {\n\t\tdisplay: none;\n\t}\n}\n\n.tooltip {\n\tposition: fixed;\n\tbackground-color: #333;\n\tcolor: var(--white-color);\n\tpadding: 4px 8px;\n\tborder-radius: 4px;\n\tfont-size: 12px;\n\twhite-space: nowrap;\n\tz-index: 950000;\n}\n\n.defaultBgButton {\n\tposition: absolute;\n\ttop: 0px;\n\tright: 0px;\n\tborder-radius: 4px;\n\tbackground: var(--_16c098-color);\n\tcolor: var(--white-color);\n\tpadding: 3px 8px;\n\tdisplay: flex;\n\tcursor: pointer;\n\tuser-select: none;\n\tfont-size: 11px;\n\talign-items: center;\n\tjustify-content: center;\n\ttransition: background 0.2s ease-in-out;\n\t&:hover {\n\t\tbackground-color: var(--e6fff9-background);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"preview": `preview_wAqjx`,
	"left": `left_fKA7H`,
	"title": `title_PR4hd`,
	"options": `options_nq74y`,
	"color": `color_FGC9x`,
	"border": `border_EWrWl`,
	"form": `form_rlURZ`,
	"shows": `shows_omyiz`,
	"right": `right_uqinm`,
	"input": `input_hTCcN`,
	"header": `header_gK1hO`,
	"buttonsNavs": `buttonsNavs_SwPBl`,
	"buttons": `buttons_yXzkD`,
	"calendar": `calendar_XHVXd`,
	"footer": `footer_eGrwK`,
	"date": `date_FTHAO`,
	"toDay": `toDay_YaOPB`,
	"actualToday": `actualToday_tgRKV`,
	"saveCalendarTitle": `saveCalendarTitle_i2LBy`,
	"colorCard": `colorCard_DqJCW`,
	"tooltip": `tooltip_YZ3hM`,
	"defaultBgButton": `defaultBgButton_u2OQE`
};
export default ___CSS_LOADER_EXPORT___;
